import { Instance } from 'mobx-state-tree';
import { RouteDriverUpdateDtoModelBase } from './RouteDriverUpdateDtoModel.base';

/* The TypeScript type of an instance of RouteDriverUpdateDtoModel */
export interface RouteDriverUpdateDtoModelType extends Instance<typeof RouteDriverUpdateDtoModel.Type> {}

/* A graphql query fragment builders for RouteDriverUpdateDtoModel */
export { selectFromRouteDriverUpdateDto, routeDriverUpdateDtoModelPrimitives, RouteDriverUpdateDtoModelSelector } from './RouteDriverUpdateDtoModel.base';

/**
 * RouteDriverUpdateDtoModel
 *
 * Schema to propagate changes on the driver assigned to a given route
 */
export const RouteDriverUpdateDtoModel = RouteDriverUpdateDtoModelBase
  .actions(self => ({
    // This is an auto-generated example action.
    log() {
      console.log(JSON.stringify(self));
    },
  }));
